export const NAME = 'billetterie';

// Catalogue du mur de la zone : à garder aligné sur ticketing.catalogRef du tenant Fnac de Plebicard V2
export const BILLETTERIE_CATALOG_REF = 'reduccine.fr';

export const REQUEST_BILLETTERIE_PARTNERS = 'REQUEST_BILLETTERIE_PARTNERS';
export const RECEIVE_BILLETTERIE_PARTNERS = 'RECEIVE_BILLETTERIE_PARTNERS';
export const FAILURE_BILLETTERIE_PARTNERS = 'FAILURE_BILLETTERIE_PARTNERS';



// WEBPACK FOOTER //
// ./src/services/billetterie/constants.js